export default function (close, vehicleId, mileages, keepers, vehicleSourced, addMileage, toaster, mileageSourced) {
    const vm = this;

    vm.newMileage = {};
    vm.vehicleSourced = [];
    vm.keepers = keepers;
    vm.mileageSourced = [];

    /* --- */

    vm.closeModal = close;
    vm.create = create;

    /* --- */

    vehicleSourced.then(s => {
        vm.vehicleSourced = s;
    });

    mileageSourced.then(x => {
        vm.mileageSourced = x;
    });

    /* --- */

    function create() {
        if (vm.form.$invalid) {
            return;
        }
        addMileage(vehicleId, vm.newMileage)
        .then(() => {
            const relatedMileageSource = vm.mileageSourced.find(x => x.id === vm.newMileage.source);
            if (relatedMileageSource) {
                vm.newMileage.source = relatedMileageSource.description;
            }

            mileages.push(vm.newMileage);

            toaster.success('Mileage created');
            close();
        });
    }
}



// WEBPACK FOOTER //
// ./Client/app/tasks/controllers/mileages/add/addMileageCtrl.js